import request from '@/utils/request'
import qs from 'qs'

const getQuestionsById = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-questions/${id}`,
    method: 'get'
  })
}

const getQuestionsPageList = (query) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-questions/page-list`,
    method: 'get',
    params: query,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

function createQuestions(data) {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-questions`,
    method: 'post',
    data
  })
}

const updateQuestions = (id, data) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-questions/${id}`,
    method: 'put',
    data
  })
}

// const updateQuestionsState = (id, state) => {
//   return request({
//     url: `${process.env.VUE_APP_BOYUAN_API}/exam-questions/${id}/state`,
//     method: 'put',
//     params: { state }
//   })
// }

export default {
  createQuestions,
  updateQuestions,
  getQuestionsById,
  getQuestionsPageList
  // updateQuestionsState
}
